
import EnumSelect from '../../../types/global.d';
import { t } from "@lingui/core/macro";

export enum CuttingState {
    Upcoming = "Upcoming",InProgress = "In progress",Finished = "Finished",Closed = "Closed",
}

export enum CuttingStateDisplay {
    Upcoming = "Upcoming",InProgress = "InProgress",Finished = "Finished",Closed = "Closed",
}

export const CuttingStatePairs = Object.keys(CuttingState)
  .map(key=> ({id: key, name: CuttingState[key]}));

export function toString(value?: EnumSelect): string {
  return value ? CuttingState[value.id] : '';
}

export function toStringDisplay(value?: string): string | undefined {
    switch (value) {
            
        case CuttingStateDisplay.Upcoming:
            return t`Upcoming`;
            
        case CuttingStateDisplay.InProgress:
            return t`In progress`;
            
        case CuttingStateDisplay.Finished:
            return t`Finished`;
            
        case CuttingStateDisplay.Closed:
            return t`Closed`;
            
        default:
            return undefined;
    }
}
